import { defineMessages } from "react-intl"

export default defineMessages({
  iHaveReadAndAcceptThe: {
    defaultMessage: "I have read and accept the",
    id: "src.components.CreateRental.iHaveReadAndAcceptThe",
  },
  none: {
    defaultMessage: "None",
    id: "src.components.CreateRental.none",
  },
  markets: {
    defaultMessage: "Markets",
    id: "src.components.CreateRental.markets",
  },
  scheduleARental: {
    defaultMessage: "Schedule a Rental",
    id: "src.components.CreateRental.scheduleARental",
  },
  station: {
    defaultMessage: "Station",
    id: "src.components.CreateRental.station",
  },
  startDate: {
    defaultMessage: "Start Date",
    id: "src.components.CreateRental.startDate",
  },
  startTime: {
    defaultMessage: "Start Time",
    id: "src.components.CreateRental.startTime",
  },
  endDate: {
    defaultMessage: "End Date",
    id: "src.components.CreateRental.endDate",
  },
  endTime: {
    defaultMessage: "End Time",
    id: "src.components.CreateRental.endTime",
  },
  rentalSuccessfullyScheduled: {
    defaultMessage: "Rental successfully scheduled!",
    id: "src.components.CreateRental.rentalSuccessfullyScheduled",
  },
  findAvailableVehicles: {
    defaultMessage: "Find Available Vehicles",
    id: "src.components.CreateRental.findAvailableVehicles",
  },

  loginToReserve: {
    defaultMessage: "Login to Reserve",
    id: "src.components.CreateRental.loginToReserve",
  },
  rentalReason: {
    defaultMessage: "Rental Reason",
    id: "src.components.CreateRental.rentalReason",
  },

  reserveVehicle: {
    defaultMessage: "Reserve Vehicle",
    id: "src.components.CreateRental.reserveVehicle",
  },
  results: {
    defaultMessage: "Results",
    id: "src.components.CreateRental.results",
  },
  next: {
    defaultMessage: "Next",
    id: "src.components.CreateRental.next",
  },
})
